module.exports = __webpack_public_path__ + "static/media/fuel.9821b09b.svg";